import React from "react";
import { FaGlobe, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { hotelInvoiceData } from "../data/hotelInvoiceData";

const HotelTemplate = () => {
const data =hotelInvoiceData;
  const invoice = {
    hotel: {
      name: data?.hotel?.name || "",
      logo: data?.hotel?.logo || "/logo1.png",
      address: data?.hotel?.address || "",
      phone: data?.hotel?.phone || "",
      website: data?.hotel?.website || ""
    },
    invoiceNumber: data?.invoiceNumber || "",
    dateIssued: data?.dateIssued || "",
    client: {
      name: data?.client?.name || "",
      address: data?.client?.address || "",
      phone: data?.client?.phone || ""
    },
    roomNumber: data?.roomNumber || "",
    checkIn: data?.checkIn || "",
    checkOut: data?.checkOut || "",
    items: Array.isArray(data?.items) ? data.items : [],
    summary: {
      subtotal: data?.summary?.subtotal || "0.00",
      taxes: data?.summary?.taxes || "0.00",
      serviceCharge: data?.summary?.serviceCharge || "0.00",
      total: data?.summary?.total || "0.00"
    },
    bank: {
      name: data?.bank?.name || "",
      accountName: data?.bank?.accountName || "",
      accountNo: data?.bank?.accountNo || ""
    }
  };

  const goldPrimary = "text-[#D4AF37]";
  const goldBg = "bg-[#F3A536]";
  const darkSlate = "bg-[#2D3436]";

  return (
    <div id="hotel-invoice" className={`${darkSlate} p-0 text-white font-sans mx-auto`}>

      <div className="flex h-56">
        <div className="w-1/2 p-8 flex flex-col justify-center">
          {!invoice.hotel.logo ? (
            <img src="/logo1.png" alt="Hotel Logo" className="h-14 mb-3 object-contain" />
          ) : (
            <h1 className={`text-3xl font-serif tracking-widest ${goldPrimary}`}>
              {invoice.hotel.name}
            </h1>
          )}
          <div className={`${goldBg} h-1 w-full my-3`}></div>
          <h2 className="text-5xl font-light tracking-tight uppercase">Invoice</h2>
        </div>

        <div className="w-1/2 bg-gray-700 relative overflow-hidden">
          {data?.hotel?.banner ? (
            <img src="/hotel.png" alt="Hotel" className="absolute inset-0 w-full h-full object-cover" />
          ) : (
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center italic text-gray-400">
              Hotel Image
            </div>
          )}
        </div>
      </div>

      <div className="p-8 grid grid-cols-2 gap-8 text-sm">
        <div>
          <h3 className="font-bold text-gray-400 mb-2 uppercase tracking-widest">Bill To</h3>
          <p className="text-lg font-medium">{invoice.client.name}</p>
          <p className="text-gray-300">{invoice.client.address}</p>
          <p className="text-gray-300">{invoice.client.phone}</p>
        </div>
        <div className="text-right space-y-1">
          <p className="text-gray-400">Invoice No: <span className="text-white ml-3">{invoice.invoiceNumber}</span></p>
          <p className="text-gray-400">Date: <span className="text-white ml-3">{invoice.dateIssued}</span></p>
          <p className="text-gray-400">Room: <span className="text-white ml-3 font-bold">{invoice.roomNumber}</span></p>
          <p className="text-gray-400">Check In: <span className="text-white ml-3">{invoice.checkIn}</span></p>
          <p className="text-gray-400">Check Out: <span className="text-white ml-3">{invoice.checkOut}</span></p>
        </div>
      </div>

      <div className="px-8">
        <table className="w-full text-left">
          <thead>
            <tr className={`${goldBg} text-white uppercase text-xs font-bold`}>
              <th className="p-2">Description</th>
              <th className="p-2 text-center">Qty</th>
              <th className="p-2 text-center">Rate (₹)</th>
              <th className="p-2 text-right">Amount (₹)</th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-600">
            {invoice.items.map((item, i) => (
              <tr key={i}>
                <td className="p-2 border-b border-gray-600">{item.desc}</td>
                <td className="p-2 text-center border-b border-gray-600">{item.qty}</td>
                <td className="p-2 text-center border-b border-gray-600">₹ {item.rate}</td>
                <td className="p-2 text-right border-b border-gray-600">₹ {item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-8 flex justify-between items-start mt-3">
        <div className="w-1/2">
          <h4 className="font-bold text-gray-100 mb-2 text-sm">Payment Details</h4>
          <div className="text-xs text-gray-400 space-y-1">
            <p>Bank: <span className="text-gray-200 ml-3">{invoice.bank.name}</span></p>
            <p>Account Name: <span className="text-gray-200 ml-3">{invoice.bank.accountName}</span></p>
            <p>Account No: <span className="text-gray-200 ml-3">{invoice.bank.accountNo}</span></p>
          </div>
        </div>

        <div className="w-64 space-y-2 text-sm">
          <div className="flex justify-between text-gray-400"><span>Subtotal</span><span>₹ {invoice.summary.subtotal}</span></div>
          <div className="flex justify-between text-gray-400"><span>Taxes</span><span>₹ {invoice.summary.taxes}</span></div>
          <div className="flex justify-between text-gray-400"><span>Service Charge</span><span>₹ {invoice.summary.serviceCharge}</span></div>
          <div className="flex justify-between border-2 border-[#F3A536] p-3 font-bold text-lg mt-3">
            <span>Total</span>
            <span className={goldPrimary}>₹ {invoice.summary.total}</span>
          </div>
        </div>
      </div>

      <div className={`${goldBg} mt-auto py-2 px-8 flex justify-between text-[10px] font-bold text-[#2D3436]`}>
        <div className="flex items-center gap-2 text-white">
          <FaPhoneAlt className="text-[12px]" /> {invoice.hotel.phone}
        </div>
        <div className="flex items-center gap-2 text-white">
          <FaMapMarkerAlt className="text-[12px]" /> {invoice.hotel.address}
        </div>
        <div className="flex items-center gap-2 text-white">
          <FaGlobe className="text-[12px]" /> {invoice.hotel.website}
        </div>
      </div>

    </div>
  );
};

export default HotelTemplate;
